import { IntegrationKind } from "@redotech/redo-integrations-core";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getReviewsWorkspaceAccess = {
  name: "getReviewsWorkspaceAccess" as const,
  mutates: false,
  input: z.null(),
  output: z.object({
    workspaceAvailable: z.boolean(),
    nativeReviewsEnabled: z.boolean(),
    hasStoredReviews: z.boolean(),
    connectedProviders: z.array(createEnum(IntegrationKind)),
  }),
};
